import '../../../../../assets/css/setContract_forSubmission.css';
import React, { useState, useEffect } from 'react';
import Fab from '@mui/material/Fab';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, FormControl, InputLabel, Select, MenuItem,
  InputAdornment, Backdrop, CircularProgress, Button, FormControlLabel, Checkbox, Alert
} from '@mui/material';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Contract_content_view from './contract_content_view';
import { contract_check, get_directions_and_responsible, get_contract_values_lists } from '../../../../../services/purchase_service';
import { get_contracts_types } from '../../../../../services/for_allServices';

function SetContract_forSubmission({ setContract, handleCloseSetContrat, chosenSubmission, purchase_service }) {
  const [contracts_types, setContracts_types] = useState(null);
  const [contract_type, setContract_type] = useState(null);
  const [contract_subtypes, setContract_subtypes] = useState(null);
  const [waiting, setWaiting] = useState(true);

  const [contractSubject, setContractSubject] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [durationYears, setDurationYears] = useState('');
  const [isRenewable, setIsRenewable] = useState(false);
  const [penalties, setPenalties] = useState('');
  const [terminationConditions, setTerminationConditions] = useState('');
  const [deliverables, setDeliverables] = useState([]);
  const [applicableLaw, setApplicableLaw] = useState('');
  const [contract_details, setContract_details] = useState(null);
  const [directors, setDirectors] = useState([]);
  const [directions, setDirections] = useState([]);
  const [director, setDirector] = useState('');
  const [direction, setDirection] = useState('');

  const [valuesLists, setValuesLists] = useState({
    financial_terms: [],
    billing_terms: [],
    payment_terms: [],
  });

  const [financialTerms, setFinancialTerms] = useState(''); //  store ID
  const [billingTerms, setBillingTerms] = useState('');
  const [paymentTerms, setPaymentTerms] = useState('');


  function ChooseTypeContrat(index, type) {
    setContract_type(type);
    setContract_subtypes(contracts_types[type]);
  }
  useEffect(() => {
    contract_check(chosenSubmission, "all").then((response) => {
      if (response.data !== "") {
        //console.log(response.data);
        let rep = response.data;
        setContract_type(Object.keys(rep)[0]);
        setContract_subtypes(rep[Object.keys(rep)[0]]);
        setWaiting(false);
      }
      else {
        get_contracts_types().then((response) => {
          //console.log(response.data);
          setContracts_types(response.data);
          setWaiting(false);
        }).catch((error) => {
          //console.log(error.response);
        })
      }
    }).catch((error) => {
      //console.log(error.response);
    })
    get_directions_and_responsible().then((res) => {
      console.log("Directions and directors: ", res.data);
      setDirectors(res.data.directors || []);
      setDirections(res.data.directions || []);
    })
      .catch((err) => {
        console.error("Error fetching directions and departments: ", err);
      })
    get_contract_values_lists().then((res) => {
      console.log("values: ", res.data);
      setValuesLists(res.data);

    }).catch((err) => {
      console.error("Error fetching directions and departments: ", err);
    })

  }, [])
  const add_contract_details = () => {
    const contractData = {
      subject: contractSubject,
      start_date: startDate,
      end_date: endDate,
      duration_years: parseInt(durationYears),
      renewable: isRenewable,
      financial_terms: financialTerms,
      billing_terms: billingTerms,
      payment_terms: paymentTerms,
      late_penalties: penalties,
      termination_conditions: terminationConditions,
      deliverables: deliverables,
      applicable_law: applicableLaw,
      director: director,
      direction: direction,
    };
    setContract_details(contractData);
    console.log("Contract Data to Submit:", contractData);
    // Submit to backend API here
  };
  const handleDirectionChange = (e) => {
    const selected_direction_id = e.target.value;
    setDirection(selected_direction_id);

    const direction_object = directions.find(dir => dir.id === selected_direction_id);
    if (direction_object && direction_object.director) {
      setDirector(direction_object.director);
    }
  }



  return (
    <>{
      waiting === true
        ? <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 3 }}
          open={waiting}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        : <Dialog disableEnforceFocus fullWidth={true} maxWidth={'md'} open={setContract} onClose={handleCloseSetContrat} aria-labelledby="form-dialog-title" >
          <DialogTitle id="form-dialog-title">Entrez les détails du contrat </DialogTitle>
          {
            contract_type == null && contract_subtypes == null
              ? <><DialogContent className="rateEdit" >
                <div className="add_product_modal_infos">
                  <div className="inputs_container" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                    gap: '20px',
                    alignItems: 'start'
                  }}>
                    <TextField
                      variant="outlined"
                      label="Objet du contrat"
                      className="input_form"
                      fullWidth
                      size="small"
                      value={contractSubject}
                      onChange={(e) => setContractSubject(e.target.value)}
                    />
                    <FormControl variant="outlined" className="input_form" fullWidth size="small">
                      <InputLabel>Direction</InputLabel>
                      <Select
                        value={direction}
                        onChange={handleDirectionChange}
                        label="Direction"
                      >
                        {directions.map((val, index) => (
                          <MenuItem key={"Direction-" + index} value={val.id}>
                            {val.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl variant="outlined" className="input_form" fullWidth size="small">
                      <InputLabel>Responsable</InputLabel>
                      <Select
                        value={director}
                        onChange={(e) => setDirector(e.target.value)}
                        label="Departement"
                      >
                        {directors.map((val, index) => (
                          <MenuItem key={"Responsable-" + index} value={val.id}>
                            {val.fullName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <TextField
                      variant="outlined"
                      label="Date de début"
                      type="date"
                      className="input_form"
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />

                    <TextField
                      variant="outlined"
                      label="Date de fin"
                      type="date"
                      className="input_form"
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />

                    <TextField
                      variant="outlined"
                      label="Durée (ans)"
                      type="number"
                      className="input_form"
                      fullWidth
                      size="small"
                      value={durationYears}
                      onChange={(e) => setDurationYears(e.target.value)}
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isRenewable}
                          onChange={(e) => setIsRenewable(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Renouvelable"
                      sx={{ marginLeft: '8px' }}
                    />

                    <FormControl variant="outlined" className="input_form" fullWidth size="small">
                      <InputLabel>Conditions financières</InputLabel>
                      <Select
                        value={financialTerms}
                        onChange={(e) => setFinancialTerms(e.target.value)}
                        label="Conditions financières"
                      >
                        {valuesLists.financial_terms?.map((item) => (
                          <MenuItem key={item.code} value={item.code}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>


                    <FormControl variant="outlined" className="input_form" fullWidth size="small">
                      <InputLabel>Conditions de facturation</InputLabel>
                      <Select
                        value={billingTerms}
                        onChange={(e) => setBillingTerms(e.target.value)}
                        label="Conditions de facturation"
                      >
                        {valuesLists.billing_terms?.map((item) => (
                          <MenuItem key={item.code} value={item.code}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>


                    <FormControl variant="outlined" className="input_form" fullWidth size="small">
                      <InputLabel>Conditions de paiement</InputLabel>
                      <Select
                        value={paymentTerms}
                        onChange={(e) => setPaymentTerms(e.target.value)}
                        label="Conditions de paiement"
                      >
                        {valuesLists.payment_terms?.map((item) => (
                          <MenuItem key={item.code} value={item.code}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      variant="outlined"
                      label="Pénalités de retard"
                      className="input_form"
                      fullWidth
                      size="small"
                      value={penalties}
                      onChange={(e) => setPenalties(e.target.value)}
                      multiline
                      rows={3}
                    />

                    <TextField
                      variant="outlined"
                      label="Conditions de résiliation"
                      className="input_form"
                      fullWidth
                      size="small"
                      value={terminationConditions}
                      onChange={(e) => setTerminationConditions(e.target.value)}
                      multiline
                      rows={3}
                    />

                    <FormControl variant="outlined" className="input_form" fullWidth size="small">
                      <InputLabel>Livrables</InputLabel>
                      <Select
                        multiple
                        value={deliverables}
                        onChange={(e) => setDeliverables(e.target.value)}
                        label="Livrables"
                        renderValue={(selected) => selected.join(', ')}
                      >
                        <MenuItem value="Rapport final">Rapport final</MenuItem>
                        <MenuItem value="Code source">Code source</MenuItem>
                        <MenuItem value="Documentation">Documentation</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl variant="outlined" className="input_form" fullWidth size="small">
                      <InputLabel>Droit applicable</InputLabel>
                      <Select
                        value={applicableLaw}
                        onChange={(e) => setApplicableLaw(e.target.value)}
                        label="Droit applicable"
                      >
                        <MenuItem value="Marocain">Marocain</MenuItem>
                        <MenuItem value="Français">Français</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <DialogTitle id="form-dialog-title">Choisissez type de contrat</DialogTitle>
                <br />
                <div className='contract_type_Container' style={{ width: 'fit-content' }}>
                  {
                    Object.keys(contracts_types).map((key, id) => {
                      return (
                        <div className='contract_type' style={{ margin: '15px' }}>
                          <Fab onClick={() => { ChooseTypeContrat(chosenSubmission, key); add_contract_details(); }} key={id} size="small" color="secondary"
                            style={{ backgroundColor: '#ef233c' }} aria-label="Choisissez type de contrat"> <VisibilityIcon className="my_icon" />
                          </Fab>
                          <span className='documentsTitle'> {key} </span>
                        </div>
                      )
                    })
                  }
                </div>
              </DialogContent>

              </>
              : <></>
          }
          {
            contract_type != null && contract_subtypes != null
              ? <Contract_content_view contract_type={contract_type} contract_subtypes={contract_subtypes} close_contact_type={() => { setContract_type(null); handleCloseSetContrat() }} chosenSubmission={chosenSubmission} purchase_service={purchase_service}
                contract_details={contract_details}
              />
              : <></>
          }
        </Dialog>
    }
    </>
  );
}
export default SetContract_forSubmission;